import React from "react";
import UserWalletDepositComponent from "../../../../components/private/user/userWallet/userWalletDepositComponent";

function UserWalletDepositContainer(props) {
  return <UserWalletDepositComponent />;
}

export default UserWalletDepositContainer;
